<template>
  <v-skeleton-loader
    type="text"
    class="mb-4 mt-2"
    :loading="loading"
  >
    <p
      class="mb-0 mt-2 caption grey--text text--lighten"
      data-cy="vendedor_label"
    >
      Vendedor
    </p>
    <p
      class="body-2 font-weight-bold"
      data-cy="vendedor_nome"
    >
      {{ dadosVendedor.name }}
    </p>
  </v-skeleton-loader>
</template>

<script>
export default {
  name: 'CardNomeVendedor',

  props: {
    dadosVendedor: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
